import { type FC, type PropsWithChildren } from 'react';
import { Controller, type Control } from 'react-hook-form';
import { FormControl, FormHelperText, Grid, TextField } from '@mui/material';

import { BACKGROUND_FIELD_DESCRIPTIONS } from '#apps/client-web/features/audit-form-background/constants';
import { getFormErrorAttributes } from '#apps/client-web/app/helpers/react-hook-form';
import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';
import { useFormDescriptions } from '#apps/client-web/features/settings/hooks/use-form-descriptions';

import {
  SubFormDialog,
  type SubFormDialogProps,
} from '#packages/web/layouts/dialog/templates/sub-form';

export type WeatherFormDialogProps = Pick<
  SubFormDialogProps,
  'onClose' | 'open'
> & {
  control: Control<EditAuditFormBackgroundData>;
};

export const WeatherFormDialog: FC<
  PropsWithChildren<WeatherFormDialogProps>
> = ({ open, control, onClose }) => {
  const getDescription = useFormDescriptions(BACKGROUND_FIELD_DESCRIPTIONS);

  return (
    <SubFormDialog title="Weather Condition" open={open} onClose={onClose}>
      <Grid container spacing={2}>
        <Controller
          control={control}
          name="general.weatherAtStart"
          rules={{ maxLength: 120 }}
          render={({ field, fieldState }) => (
            <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
              <TextField
                {...field}
                label="Weather conditions at start of site visit"
                type="text"
                variant="outlined"
                {...getFormErrorAttributes(fieldState.error)}
              />
              <FormHelperText>{fieldState.error?.message ?? getDescription(field.name)}</FormHelperText>
            </FormControl>
          )}
        />
        <Controller
          control={control}
          name="general.weatherAtEnd"
          rules={{ maxLength: 120 }}
          render={({ field, fieldState }) => (
            <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
              <TextField
                {...field}
                label="Weather conditions at end of site visit"
                type="text"
                variant="outlined"
                {...getFormErrorAttributes(fieldState.error)}
              />
              <FormHelperText>{fieldState.error?.message ?? getDescription(field.name)}</FormHelperText>
            </FormControl>
          )}
        />
      </Grid>
    </SubFormDialog>
  );
};
